import React from 'react'
import styled from 'styled-components'

import type { DisplayOrganizationType } from 'shared/common/global-types.d'
import { Nullable } from 'shared/utils/type-guards'

import { SIZES } from '~/common/globalStyles'
import Avatar from '~/views/components/ui/Avatar'
import Text from '~/views/components/ui/Text'

const CollaborationLogosWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
`

const ImageContainer = styled.div(
  ({ theme }) => `
  position: relative;
  height: 130px;
  width: 81px;
  margin-left: ${theme.spacing(-2)};
  margin-right: ${theme.spacing(-2)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`,
)

interface OrganizationSectionProps {
  width?: number
}

const OrganizationSection = styled.div<OrganizationSectionProps>`
  width: ${({ width }) => (width ? width : '140px')};
  align-items: center;
  text-align: center;
`

interface Props {
  provider?: DisplayOrganizationType | null
  customer?: Nullable<{
    name: string
    logo?: Nullable<{ originalUrl?: string | null }>
  }>
  isInternalProject?: boolean
  labels: {
    // "Provider"
    provider: string

    // "Customer"
    customer: string
  }
}

const CollaborationLogos: React.FC<Props> = ({
  provider,
  customer,
  isInternalProject,
  labels,
  ...props
}) => {
  if ((!provider || !customer) && !isInternalProject) return null

  return (
    <CollaborationLogosWrapper {...props}>
      <OrganizationSection style={{ float: 'left' }}>
        <Avatar
          style={{
            height: '130px',
            width: '130px',
            margin: '0 auto 4px',
            backgroundSize: 'contain',
          }}
          name1={provider?.name || ''}
          fontSize={SIZES.mega}
          imageUrl={provider?.logo?.originalUrl || ''}
        />
        <div>
          <Text weight="bold">{provider?.name}</Text>
        </div>
        <div className="logo-role">
          <Text color="mediumGray">{labels.provider}</Text>
        </div>
      </OrganizationSection>
      {!isInternalProject && (
        <>
          <ImageContainer>
            <img
              src="https://cdn.guidecx.com/static/images/double-arrow-down.png"
              alt="->"
              width="auto"
              height="14px"
            />
            <img
              src="https://cdn.guidecx.com/static/images/double-arrow-up.png"
              alt="<-"
              width="auto"
              height="14px"
            />
          </ImageContainer>
          <OrganizationSection style={{ float: 'right' }}>
            <Avatar
              style={{
                height: '130px',
                width: '130px',
                margin: '0 auto 5px auto',
                backgroundSize: 'contain',
              }}
              name1={customer?.name || ''}
              fontSize={SIZES.mega}
              imageUrl={customer?.logo?.originalUrl || ''}
            />
            <div>
              <Text weight="bold">{customer?.name}</Text>
            </div>
            <div className="logo-role">
              <Text color="mediumGray">{labels.customer}</Text>
            </div>
          </OrganizationSection>
        </>
      )}
    </CollaborationLogosWrapper>
  )
}

export default CollaborationLogos
